module.exports = __webpack_public_path__ + "static/media/logo-branca.cfdb19b1.png";